import $ from 'jquery';

/**
 * Autocomplete the form address fields using the PostCodeApi
 */
export class FormGetAddress {
  constructor() {
    this.$postalCode = $('#profile_postcode');
    this.$houseNr = $('#profile_nummer');
    this.$suffix = $('#profile_toevoeging');
    this.$city = $('#profile_stad');
    this.$street = $('#profile_straat');

    this.$suffix
      .add(this.$postalCode)
      .add(this.$houseNr)
      .on('focusout', () => this.checkForm());
  }

  /**
     * Checks if the required fields are filled and
     * the address not already has been provided
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  checkForm() {
    if (this.$postalCode.val().length > 0 && this.$houseNr.val().length > 0
            && this.$street.val().length === 0 && this.$city.val().length === 0) {
      $('.js-address-spinner')
        .html(' <i class="fa-solid fa-circle-notch fa-spin autofill__spinner-icon"></i>');

      return this.getAddress(
        this.$postalCode.val(),
        this.$houseNr.val(),
        this.$suffix.val()
      )
        .then(data => this.updateAddress(data))
        // eslint-disable-next-line no-console
        .catch(error => console.log('getAddress', error));
    }
  }

  /**
     * Completes the postcode with extension for the street number
     *
     * @param postal_code
     * @param house_number
     * @param house_number_postfix
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  getAddress(postal_code, house_number, house_number_postfix) {
    return $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'get_address_from_postalcode',
        postal_code: postal_code,
        house_number: house_number,
        house_humber_postfix: house_number_postfix,
        // nonce not required, because this doesn't
        // go via our AJAX controller yet
      },
      dataType: 'json',
    });
  }

  /**
     * Fills the street and address fields if there are no errors
     * @param result
     */
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-member-accessibility
  updateAddress(result) {
    $('.js-address-spinner .fa-solid').remove();
    if (result.street && result.city) {
      this.$street.val(result.street);
      this.$city.val(result.city);
    }
  }
}

